import { toast } from 'react-toastify';
// import { ADD_PRODUCT, DELETE_PRODUCT, OPEN_MODAL, PAY, SHOW_PANIER, UPDATE_QUANTITY } from './PanierType';
import { INIT, ADD_PRODUCT, DELETE_PRODUCT, PAY, UPDATE_QUANTITY } from './PanierType';

const detectDuplicatePanier = (orders, action) => {
    //sessionStorage.removeItem('panierState')
    let exist = "empty";
    const existFolder = orders.filter(folder => folder.folderId === action.folderId);
    if(existFolder && existFolder.length > 0) {
        exist = "in folder";
    }
    
    existFolder.forEach(folder => {
        const existBooking = folder.bookings.filter(booking => booking.bookingId === action.bookingId);
        if(existBooking && existBooking.length > 0) {
            exist = "in booking"
        }
        existBooking.forEach(booking => {
            const existInBooking = booking.supplements.filter(supp => supp.id === action.payload.id);
            if(existInBooking && existInBooking.length > 0) {
                exist = "duplicate";
            }
        });
    });
    return exist;
}

export default function PanierReducer(state, action) {
    let newState = null;
    let exist;

    if(action.type === ADD_PRODUCT) {
        exist = detectDuplicatePanier([...state.orders], action);
        if(exist === "duplicate") {
            action.type = UPDATE_QUANTITY;
        }
    }

    switch (action.type) {
        case INIT:
            if(sessionStorage.getItem('panierState')) {
                newState = JSON.parse(sessionStorage.getItem('panierState'));
            } else {
                newState = {
                    orders: [],
                    panierModal: false,
                    setPanierModal: false,
                    panierVisible: false,
                    orderPay: [],
                };
            }
            break;
        case ADD_PRODUCT:
            if(exist === "empty" ) {
                let supplement = action.payload;
                supplement.quantity = action.quantity;
                let newFolder = {
                    folderNumber: action.folderNumber,
                    folderId: action.folderId,
                    currency: action.payload.currency,
                    bookings : [
                        {
                            bookingId: action.bookingId,
                            supplements: [supplement]
                        }
                    ]
                }

                newState = { ...state, orders: [...state.orders, newFolder]};
            } else if (exist === "in folder") {
                const oldOrders = [...state.orders];
                let supplement = action.payload;
                supplement.quantity = action.quantity;

                oldOrders.forEach(order => {
                    if(order.folderId === action.folderId) {
                        order.bookings = [...order.bookings, {bookingId: action.bookingId, supplements: [supplement]}]
                    }
                })

                newState = { ...state, orders: [...oldOrders]}
            } else if (exist === "in booking") {
                const oldOrders = [...state.orders];
                let supplement = action.payload;
                supplement.quantity = action.quantity;

                oldOrders.forEach(order => {
                    if(order.folderId === action.folderId) {
                        order.bookings.forEach(booking => {
                            if(booking.bookingId === action.bookingId) {
                                booking.supplements = [...booking.supplements, supplement];
                            }
                        })
                    }
                })

                newState = { ...state, orders: [...oldOrders]}
            } else {
                newState = state
            }
            toast.success(action.messageSuccess);
            break;
        case DELETE_PRODUCT:
            const deletedOldOrders = [...state.orders];
            let empty = false;
            deletedOldOrders.forEach(order => {
                if(order.folderId === action.folderId) {
                    order.bookings.forEach(booking => {
                        if(booking.bookingId === action.bookingId) {
                            booking.supplements = booking.supplements.filter(suppl => suppl.id !== action.payload.id);

                            if(booking.supplements.length === 0) {
                                order.bookings = order.bookings.filter(bks => bks.bookingId !== action.bookingId);

                                if(order.bookings.length === 0) {
                                    empty = true;
                                }
                            }
                        }
                    })
                }
            })

            newState = empty ? { ...state, orders: [...state.orders.filter(order => order.folderId !== action.folderId)]} : { ...state, orders: [...deletedOldOrders]};
            toast.success(action.messageSuccess);
            break;
        case PAY:
            newState = { ...state, orders: [...state.orders.filter(order => order.folderId !== action.folderId)], orderPay: action.payload};
            break;
        case UPDATE_QUANTITY:
            const oldOrders = [...state.orders];
            oldOrders.forEach(order => {
                if(order.folderId === action.folderId) {
                    order.bookings.forEach(booking => {
                        if(booking.bookingId === action.bookingId) {
                            booking.supplements.forEach(suppl => {
                                if(suppl.id === action.payload.id) {
                                    suppl.quantity = action.quantity;
                                    suppl.panierTotalPrice = (action.quantity * parseFloat(suppl.price)).toFixed(2);
                                }
                            })
                        }
                    })
                }
            })

            newState = { ...state, orders: [...oldOrders]};
            toast.success(action.messageSuccess);
            break;
        default:
            //sessionStorage.setItem('panierState', JSON.stringify(state));
            newState = state;
            break;
    }
            
    sessionStorage.setItem('panierState', JSON.stringify(newState));
    return newState;
}